import { useQuery } from '@tanstack/react-query';

import { getSavedQueries } from './saved-queries-api';

export const SAVED_QUERIES_QUERY_KEY = ['saved-queries'] as const;

export function useSavedQueries({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) {
  const { data, isLoading, error } = useQuery({
    queryKey: SAVED_QUERIES_QUERY_KEY,
    queryFn: getSavedQueries,
    staleTime: 60_000,
    enabled,
  });

  return { data: data ?? [], isLoading, error };
}
